module.exports = __webpack_public_path__ + "img/9.f116ad08.png";